import React from 'react';
import { FuelButton, FuelInteractiveIcon } from '@frete.com/fuel-react';
import { whatsappTalk } from '@helpers/journeys/whatsappTalk';
import { WhatsAppButtonProsInterface } from './WhatsAppButtonTypes';

function WhatsAppButton({
  phone,
  hasButton = false,
  message,
  onCallbackSentWhatsApp,
}: WhatsAppButtonProsInterface) {
  function handleOpenWhatsApp(event) {
    event.stopPropagation();
    whatsappTalk(phone, message);

    if (onCallbackSentWhatsApp) {
      onCallbackSentWhatsApp();
    }
  }

  function handleRenderButton() {
    if (!hasButton) {
      return (
        <FuelInteractiveIcon
          data-testid="button-whatsApp"
          icon="whatsapp"
          onClick={(event) => handleOpenWhatsApp(event)}
        />
      );
    }

    return (
      <FuelButton
        data-testid="button-whatsApp"
        variant="secondary"
        size="small"
        leadingIcon="whatsapp"
        onlyIcon
        onClick={(event) => handleOpenWhatsApp(event)}
        disabled={!phone}
      />
    );
  }
  return <>{handleRenderButton()}</>;
}

export default WhatsAppButton;
